<ng-container *transloco="let t">
	<div class="container is-fluid m-0 p-0">
		<div class="card is-fullwidth" style="border: #bcd872 solid 1px">
			<header
				class="card-header card-header-title is-centered has-background-dark has-text-white">
				{{ title() }}
			</header>
			<div class="card-content pt-2 pb-0">
				<div class="content">
					<div class="columns is-small mb-0 is-vcentered">
						<div class="column">
							<eventlyte-tag-list-field
								formKey="registrationStatus"
								[formGroup]="formGroup"
								[label]="t('fields.registrationStatus.label')"
									[value]="getRecordValue(record, 'registrationStatus')"
								(valueChange)="setRecordValue(record, 'registrationStatus', $event)"
								[editing]="false"
								[deselectable]="false"
							>
								<eventlyte-tag-field
									value="Waiting for Approval"
									[label]="t('fields.registrationStatus.options.Waiting for Approval')"
									[hasExtraText]="false"
									[background]="ViewColor.Light"
								/>
								<eventlyte-tag-field
									value="Success"
									[label]="t('fields.registrationStatus.options.Success')"
									[hasExtraText]="false"
									[background]="ViewColor.Light"
								/>
								<eventlyte-tag-field
									value="Rejected"
									[label]="t('fields.registrationStatus.options.Rejected')"
									[hasExtraText]="false"
									[background]="ViewColor.Light"
								/>
							</eventlyte-tag-list-field>

							<eventlyte-text-field
								[label]="t('content.fields.referenceNumber')"
								[editing]="false"
								class="is-block mt-2"
								[value]="getRecordValue(record, 'cardNumber')" />

							<eventlyte-field-label [label]="t('content.fields.registrationType')" />

							<span class="pb-2 is-block">{{
								'fields.badgeType.options.' +
									getRecordValue(record, 'badgeType').value | transloco
							}}</span>

							<eventlyte-text-field
								[label]="t('content.fields.name')"
								[editing]="false"
								[value]="getFullName()" />
						</div>
						<div
							class="column is-narrow is-hidden-mobile is-flex is-justify-content-center m-1 p-1">
							<div
								class="is-flex is-flex-direction-column is-align-items-center mt-5 mr-5">
								@if (isConfirmed()) {
									<eventlyte-barcode-image-field
										[width]="barcodeWidth()"
										[value]="
											getRecordValue(record, 'cardNumber') ?? 'Unknown'
										" />
									<eventlyte-text-field
										[editing]="false"
										class="is-block mt-2"
										[value]="getRecordValue(record, 'cardNumber')" />
								}
							</div>
						</div>
					</div>
				</div>

				<div class="columns is-mobile is-gapless m-0 p-1 is-hidden-tablet">
					<div class="column is-12 is-flex is-justify-content-center mt-2 mb-2">
						@if (isConfirmed()) {
							<eventlyte-barcode-image-field
								[width]="barcodeWidth()"
								[value]="getRecordValue(record, 'cardNumber') ?? 'Unknown'" />
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
